import React, { useEffect, useRef, useState } from 'react'
import _ from "lodash";
import MaterialTable from "material-table";
import { MTableToolbar } from "material-table";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import ContentLoader from "react-content-loader";
import { useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import axios from "axios";

import authHeader from '../../../services/auth-header';
import { API } from '../../../backend';
import { getTrans as t } from "../../../Localization/translations";
import Helper from '../../../Helper';
import Scheduler from '../../schedule';
import AddProcessingService from '../../../services/Processing/createProcessing';
import Tooltip from '@tippyjs/react';
import GetProcessingService from '../../../services/Processing/processview';


const ScheduleProcess = ({ id, setContract_number, schedule, setSchedule, setShowScheduler, setSelectedValue, selectedValue, setBillTroughDate, billtroughdate, GenrateBilltableRef,
    showScheduler,
    setScheduleType,
    scheduleType,
    setStartDate,
    startDate,
    setStartTime,
    startTime,
    setEndDate,
    endDate,
    setEndTime,
    endTime,
    setRerunInterval,
    rerunInterval,
    setRerunUnit,
    rerunUnit,
    setSelectedMonths,
    selectedMonths,
    setSelectedDates,
    selectedDates,
    setFrequency,
    frequency,
    setSelectedWeekdays,
    selectedWeekdays,
    setIncrementParams,
    incrementParams,
    setRecalculateParams,
    recalculateParams,
    setIsLoading,
    isLoading,
    moniter,
    setMoniter
}) => {
    const navigate = useNavigate();
    const [billloading, setBillLoading] = useState(true);
    const [selectedValue3, setSelectedValue3] = useState("");
    const [flag, setFlag] = useState("");
    const [flagNotification, setFlagNotification] = useState("");
    const [invoice_series, setInvoiceSeries] = useState("");
    const [successful, setSuccessful] = useState(false);
    const [permissionss, setPermission] = useState(localStorage.getItem('permissions'))
    const permissionsArray = permissionss.split(',');
    const [disable, setDisable] = useState(false);

    const [isLoading2, setIsLoading2] = useState(false);
    const [inputvalue2, setValue2] = useState("");
    const [currentPage2, setCurrentPage2] = useState(1);
    const [options2, setOptions2] = useState([]);

    // State for view process 
    const [request_id, setRequestID] = useState("")
    const [process_name, setProcessName] = useState("")
    const [parameter1, setParameter1] = useState("")
    const [parameter2, setParameter2] = useState("")
    const [status, setStatus] = useState("")
    const [error_details, setErrorDetails] = useState("")
    const [next_run_date, setNextRunDate] = useState("")

    const formatDate = (date) => {
        const newDate = new Date(date);
        const year = newDate.getFullYear();
        const month = String(newDate.getMonth() + 1).padStart(2, '0');
        const day = String(newDate.getDate()).padStart(2, '0');
        const hours = String(newDate.getHours()).padStart(2, '0');
        const minutes = String(newDate.getMinutes()).padStart(2, '0');
        const seconds = String(newDate.getSeconds()).padStart(2, '0');
        // FIX: this used to build dateFormatted/timeFormatted from
        // newDate.toISOString(), which is always UTC — so a schedule entered
        // as 15:43 local (IST) displayed back as 10:13. The local components
        // above were already being computed correctly but never used. Use
        // them instead so the displayed time matches what the user entered.
        const dateFormatted = `${year}-${month}-${day}`;
        const timeFormatted = `${hours}:${minutes}:${seconds}`;
        return `${Helper.DateNormal(dateFormatted)}  ${timeFormatted}`;
    };

    const porcessget = (id) => {

        GetProcessingService.getProcessing(id).then(
            (response) => {
                setState2({ isPaneOpen: true })
                setRequestID(response.data.response.id)
                setProcessName(response.data.response.process_name)
                setParameter1(response.data.response.parameter1)
                setParameter2(response.data.response.parameter2)
                setStatus(response.data.response.status)
                setErrorDetails(response.data.response.process_log)
                setNextRunDate(response.data.response.next_run_date)
            }
        )
    }

    const checkBtn = useRef();
    const {
        handleSubmit,
    } = useForm();
    const form = useRef();

    let localDateTime = new Date();
    let startDateValue = localDateTime.toISOString().split('T')[0];

    const hadelRefresh = () => {
        GenrateBilltableRef.current.onQueryChange();
        setBillTroughDate(new Date())

    };

    const handleReset = () => {
        setSelectedValue3("");
        GenrateBilltableRef.current.onQueryChange();
    };
    const [state1, setState] = useState({
        isPaneOpen: false,
        isPaneOpenLeft: false,
    });

    const [state2, setState2] = useState({
        isPaneOpen: false,
        isPaneOpenLeft: false,
    });
    const [error, setError] = useState(false);

    // Edit-schedule state
    const [state3, setState3] = useState({ isPaneOpen: false });
    const [editProcessId, setEditProcessId] = useState(null);
    const [editDate, setEditDate] = useState('');
    const [editTime, setEditTime] = useState('');
    const [editSaving, setEditSaving] = useState(false);

    const openEditSchedule = (rowData) => {
        const current = new Date(rowData.next_run_date);
        const pad = (n) => String(n).padStart(2, '0');
        setEditProcessId(rowData.id);
        setEditDate(`${current.getFullYear()}-${pad(current.getMonth() + 1)}-${pad(current.getDate())}`);
        setEditTime(`${pad(current.getHours())}:${pad(current.getMinutes())}`);
        setState3({ isPaneOpen: true });
    };

    const handleSaveReschedule = () => {
        if (!editDate || !editTime) {
            toast.error('Please pick a date and time.');
            return;
        }
        setEditSaving(true);
        const localDateTime = new Date(`${editDate}T${editTime}`);
        const pad = (n) => String(n).padStart(2, '0');
        // Convert the user's local picks to UTC before sending — same
        // approach used when a schedule is first created (toUTCDateTimeString
        // in handleschedule), so what gets stored matches what they picked.
        const utcString = `${localDateTime.getUTCFullYear()}-${pad(localDateTime.getUTCMonth() + 1)}-${pad(localDateTime.getUTCDate())} ${pad(localDateTime.getUTCHours())}:${pad(localDateTime.getUTCMinutes())}`;

        GetProcessingService.rescheduleProcessing(editProcessId, utcString).then((res) => {
            setEditSaving(false);
            if (res.data.success) {
                toast.success(res.data.response || 'Schedule updated successfully', {
                    position: "top-right",
                    autoClose: 1000,
                });
                setState3({ isPaneOpen: false });
                GenrateBilltableRef.current.onQueryChange();
            } else {
                toast.error(res.data.error || 'Failed to update schedule');
            }
        }).catch(() => {
            setEditSaving(false);
            toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com');
        });
    };

    const handelChangebilling = (value) => {
        setSelectedValue3(value);
    };

    useEffect(() => {
        setBillLoading(false);
    }, [id]);

    const invoice_number_method = async () => {
        await axios
            .get(API + `billing/invoice_number_method/`, { headers: authHeader() })
            .then((response) => {
                if (response.data.success === 1) {
                    setInvoiceSeries(response.data.details);
                    // handleRegister();
                } else {
                    confirmAlert({
                        title: "",
                        message: "Go to settings and update Invoice Setting",
                        buttons: [
                            {
                                label: "OK",
                                onClick: () => navigate("/additionalsettings"),
                            },
                        ],
                    });
                }
            })
    };

    const loadOptionsbilling = async () => {
        GenrateBilltableRef.current.onQueryChange();
    };

    const handleschedule = () => {
        let billthroughDateFormatted = billtroughdate
            ? billtroughdate.toLocaleDateString("en-CA")
            : new Date().toLocaleDateString("en-CA");
        if (scheduleType === 'once') {
            setIsLoading(true)
            const localDateTime = new Date(`${startDate}T${startTime}`)
            const taskTime = localDateTime.toISOString().split('.')[0] + 'Z';

            const value = {
                task_type: 'specific',
                task_time: taskTime,
                process_name: moniter,
                parameter1: selectedValue ? selectedValue.id : "",
                parameter2: billthroughDateFormatted,
                start_date: startDate !== '' ? startDate : startDateValue,
            }
            axios.post(API + 'helper/schedule-task/', value,
                {
                    headers: authHeader()
                }
            ).then((res) => {
                if (res.data.success === 1) {
                    setStartDate('')
                    setEndDate('')
                    setStartTime('')
                    setEndTime('')
                    setFrequency('')
                    setScheduleType('instant');
                    setSelectedValue(null);
                    setContract_number('');
                    setRerunUnit('')
                    setIsLoading(false)
                    setBillTroughDate(new Date())
                    toast.success(res.data.response)

                }
                setTimeout(() => {
                    setShowScheduler(false)
                    GenrateBilltableRef.current.onQueryChange();
                }, 1000);
            }).catch((e) => {
                setIsLoading(false)
                setShowScheduler(false)
            })
            // }
        } else {
            const toUTCDateTimeString = (date) => {
                const pad = (n) => String(n).padStart(2, '0');
                return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())} ${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`;
            };
            const localDateTime = new Date(`${startDate}T${startTime}`);
            const formattedStartDate = toUTCDateTimeString(localDateTime);
            const formattedEndDate = endDate ? toUTCDateTimeString(new Date(`${endDate}T${endTime}`)) : '';
            const taskTime = localDateTime.toISOString().split('.')[0] + 'Z';
            // if (rerunInterval === '') {
            //     const value = {
            //         task_type: 'custom',
            //         task_time: taskTime,
            //         interval_type: rerunUnit,
            //         interval_value: rerunInterval,
            //         start_date: formattedStartDate,
            //         end_date: formattedEndDate !== ''? formattedEndDate:null,
            //         // month: finalMonths,
            //         month: selectedMonths,
            //         days_of_month: selectedDates,
            //         days_of_week: selectedWeekdays,
            //         process_name: moniter,
            //         parameter1: selectedValue ? selectedValue.id : "",
            //         parameter2: startDate !== '' ? startDate : startDateValue,
            //     }
            //     axios.post(API + 'helper/schedule-task/', value,
            //         {
            //             headers: authHeader()
            //         }
            //     ).then((res) => {
            //         if (res.data.success === 1) {
            //             setStartDate('')
            //             setEndDate('')
            //             setFrequency('')
            //             setStartTime('')
            //             setEndTime('')
            //             setIsLoading(false)
            //             setScheduleType('instant')
            //             setTimeout(() => {
            //                 setShowScheduler(false)
            //                 GenrateBilltableRef.current.onQueryChange();
            //             }, 1000);
            //         }
            //     }).catch((e) => {
            //         setIsLoading(false)
            //     })
            // } else {
            if (rerunUnit !== '') {
                setError(false)
                const value = {
                    task_type: 'periodic',
                    task_time: taskTime,
                    interval_type: rerunUnit,
                    // interval_value: rerunInterval !== '' ? rerunInterval : null,
                    interval_value: 1,
                    start_date: formattedStartDate,
                    end_date: endDate ? formattedEndDate : null,
                    process_name: moniter,
                    parameter1: selectedValue ? selectedValue.id : "",
                    parameter2: billthroughDateFormatted,
                }
                axios.post(API + 'helper/schedule-task/', value,
                    {
                        headers: authHeader()
                    }
                ).then((res) => {
                    if (res.data.success === 1) {
                        toast.success(res.data.response)
                        setStartDate('')
                        setEndDate('')
                        setFrequency('')
                        setStartTime('')
                        setEndTime('')
                        setRerunUnit('')
                        setIsLoading(false)
                        setScheduleType('instant')
                        setSelectedValue('')
                        setBillTroughDate(new Date())
                    }
                    setTimeout(() => {
                        setShowScheduler(false)
                        GenrateBilltableRef.current.onQueryChange();
                    }, 1000);
                }).catch((e) => {
                    setIsLoading(false)
                })
            }
            else {
                setError(true)
            }
            // }
        }
    }

    const handelCancelSchedule = (id, status) => {
        confirmAlert({
            title: "",
            message: "Are you sure you want to cancel this process?.",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        GetProcessingService.cancelProcessing(
                            id
                        ).then((response) => {
                            if (response.data.success) {
                                toast.success(`${response.data.response}`, {
                                    position: "top-right",
                                    autoClose: 1000,
                                    hideProgressBar: false,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                });
                                GenrateBilltableRef.current.onQueryChange();

                            } else {
                                toast.error(`${response.data.error}`, {
                                    position: "top-right",
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                });
                            }
                        })
                            .catch((error) => {
                                toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
                                    position: "top-right",
                                    autoClose: 4000,
                                    hideProgressBar: false,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                })

                            });
                    },
                },
                {
                    label: "No",
                },
            ],
        });
    };
    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                {billloading === false ? (
                    <div className="row" id="payschedule">
                        {/* <Form
                            role="form text-left"
                            onSubmit={handleSubmit(invoice_number_method)}
                            ref={form}
                            action="."
                            method="POST"
                        >
                            {
                                <>
                                    <div className="row">
                                        <div className="col-xl-4 processingindex">
                                        </div>
                                        <div className="col-xl-3">
                                            <div className="form-group row">
                                                <div className="col-lg-9">
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-4">
                                        </div>
                                    </div>
                                </>
                            }
                            <CheckButton style={{ display: "none" }} ref={checkBtn} />
                        </Form> */}
                        {/* <div className="form-group row"> */}
                        {showScheduler &&
                            <Scheduler
                                showScheduler={showScheduler}
                                setShowScheduler={setShowScheduler}
                                handleschedule={handleschedule}
                                onSave={() => {
                                    let billthroughDateFormatted = billtroughdate
                                        ? billtroughdate.toLocaleDateString("en-CA")
                                        : new Date().toLocaleDateString("en-CA");
                                    setIsLoading(true)

                                    AddProcessingService.addProcessing(
                                        selectedValue ? selectedValue.id : "",
                                        moniter,
                                        // startDate !== '' ? startDate : startDateValue
                                        billthroughDateFormatted
                                    ).then((response) => {
                                        if (response.data.success) {
                                            if (response.data.billing) {
                                                setFlag(flag + 1);
                                                // setLoading(false);
                                            } else {
                                                setFlagNotification(flagNotification + 1);
                                                // setLoading(false);
                                            }
                                            setSuccessful(true);
                                            setSelectedValue("");
                                            // setBillTroughDate("");
                                            axios.post(API + 'helper/schedule-task/', {
                                                "task_type": "instant",
                                                "process_name": moniter
                                            },
                                                {
                                                    headers: authHeader()
                                                }
                                            ).then((res) => {
                                                if (res.data.success === 1) {
                                                    setIsLoading(false)
                                                    setScheduleType('instant');
                                                    setSelectedValue(null);
                                                    setContract_number('');
                                                    setRerunUnit('')
                                                    setBillTroughDate(new Date())
                                                }
                                            }).catch((error) => {
                                                setIsLoading(false)
                                            })

                                            toast.success(`${response.data.response}`, {
                                                position: "top-right",
                                                autoClose: 1000,
                                                hideProgressBar: false,
                                                pauseOnHover: true,
                                                draggable: true,
                                                progress: undefined,
                                                theme: "light",
                                            });
                                            setTimeout(() => {
                                                setDisable(false);
                                                setIsLoading(false)
                                                setShowScheduler(false)
                                                GenrateBilltableRef.current.onQueryChange();
                                            }, 1000);
                                        } else {
                                            toast.error(`${response.data.error}`, {
                                                position: "top-right",
                                                autoClose: 1000,
                                                hideProgressBar: false,
                                                pauseOnHover: true,
                                                draggable: true,
                                                progress: undefined,
                                                theme: "light",
                                            });
                                            setSuccessful(false);
                                            setDisable(false);
                                            // setLoading(false);
                                            setIsLoading(false)
                                        }
                                    })
                                    // }
                                }}
                                options2={options2}
                                setIsLoading2={setIsLoading2}
                                setValue2={setValue2}
                                inputvalue2={inputvalue2}
                                setCurrentPage2={setCurrentPage2}
                                currentPage2={currentPage2}
                                isLoading2={isLoading2}
                                setOptions2={setOptions2}
                                setScheduleType={setScheduleType}
                                scheduleType={scheduleType}
                                setStartDate={setStartDate}
                                startDate={startDate}
                                setStartTime={setStartTime}
                                startTime={startTime}
                                setEndDate={setEndDate}
                                endDate={endDate}
                                setEndTime={setEndTime}
                                endTime={endTime}
                                setRerunInterval={setRerunInterval}
                                rerunInterval={rerunInterval}
                                setRerunUnit={setRerunUnit}
                                rerunUnit={rerunUnit}
                                setSelectedMonths={setSelectedMonths}
                                selectedMonths={selectedMonths}
                                setSelectedDates={setSelectedDates}
                                selectedDates={selectedDates}
                                setFrequency={setFrequency}
                                frequency={frequency}
                                setSelectedWeekdays={setSelectedWeekdays}
                                selectedWeekdays={selectedWeekdays}
                                setIncrementParams={setIncrementParams}
                                incrementParams={incrementParams}
                                setRecalculateParams={setRecalculateParams}
                                recalculateParams={recalculateParams}
                                setSchedule={setSchedule}
                                moniter={moniter}
                                setMoniter={setMoniter}
                                setSelectedValue={setSelectedValue}
                                selectedValue={selectedValue}
                                billtroughdate={billtroughdate}
                                GenrateBilltableRef={GenrateBilltableRef}
                                setIsLoading={setIsLoading}
                                isLoading={isLoading}
                                setBillTroughDate={setBillTroughDate}
                                setContract_number={setContract_number}
                                setError={setError}
                                error={error}
                            />
                        }
                        {/* </div> */}
                        <SlidingPane
                            className="some-custom-class"
                            overlayClassName="some-custom-overlay-class"
                            isOpen={state1.isPaneOpen}
                            title="Filter By"
                            subtitle=""
                            onRequestClose={() => {
                                setState({ isPaneOpen: false });
                            }}
                        >
                            <div className="col-md-12">
                                <div className="">
                                    <div className="">
                                        <div className="col-lg-12 mb-3">
                                            <label className="col-lg-5 col-form-label">
                                                {t("Request Date")}
                                            </label>
                                            <DatePicker
                                                className="form-control datepick"
                                                selected={selectedValue3}
                                                onChange={(e) => handelChangebilling(e)}
                                                placeholderText={"mm/dd/yyyy"}
                                                showYearDropdown // year show and scrolldown alos
                                                scrollableYearDropdown
                                                showMonthDropdown
                                                dropdownMode="select"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <button
                                        type="button"
                                        className="clearAll btn bg-gradient-secondary ms-auto mb-0 "
                                        onClick={handleReset}
                                    >
                                        {t("Reset")}
                                    </button>
                                    &nbsp;&nbsp;
                                    <button
                                        type="button"
                                        onClick={loadOptionsbilling}
                                        className="partyFilter add btn btn-primary ms-auto mb-0"
                                    >
                                        {t("Apply")}
                                    </button>
                                    &nbsp;&nbsp;
                                </div>
                            </div>
                        </SlidingPane>
                        <div className="col-md-12">
                            <div className="">
                                <div className="body">
                                    <div className="table-responsive">
                                        <MaterialTable
                                            tableRef={GenrateBilltableRef}
                                            title={<h5 className="mb-0" >{t("Processing")}</h5>}
                                            style={{
                                                backgroundColor: "var(--bs-table-bg)",
                                                borderBottomWidth: "1px",
                                                boxShadow:
                                                    "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                                zIndex: 0
                                            }}
                                            columns={[
                                                {
                                                    title: `${t("Request ID")}`,
                                                    field: "id",
                                                    render: (rowData) => (
                                                        <>
                                                            <div className="d-xl-none tc d-md-none d-lg-none">
                                                                {t("Request ID")}{" "}
                                                            </div>
                                                            <div className='tc text-bold hyperlink' onClick={() => { porcessget(rowData.id) }}>{rowData.id}</div>
                                                        </>
                                                    ),
                                                    defaultSort: "desc",
                                                    headerStyle: {
                                                        verticalAlign: "inherit",
                                                        fontWeight: "bold",
                                                        textAlign: "left",
                                                    },
                                                    cellStyle: {
                                                        textAlign: "left",
                                                        fontSize: 12,
                                                    },
                                                },

                                                {
                                                    title: `${t("Process Name")}`,
                                                    field: "process_name",
                                                    render: (rowData) => (
                                                        <>
                                                            <div className="d-xl-none tc d-md-none d-lg-none">
                                                                {t("Process Name")}{" "}
                                                            </div>
                                                            <div>{rowData.process_name === "Billing" ? "Generate Invoices" : rowData.process_name === "Notification" ? "Generate Notifications" : rowData.process_name === "Bucket" ? "Generate Aging Bucket" : rowData.process_name === "Contract Bulk Create" ? "Contract Bulk Create(QuickFi)" : rowData.process_name}</div>
                                                        </>
                                                    ),
                                                    headerStyle: {
                                                        verticalAlign: "inherit",
                                                        fontWeight: "bold",
                                                        textAlign: "left",
                                                    },
                                                    cellStyle: {
                                                        textAlign: "left",
                                                        fontSize: 12,
                                                    },
                                                },
                                                // {
                                                //     title: `${t("Contract Number")}`,
                                                //     field: "parameter1",
                                                //     render: (rowData) => (
                                                //         <>
                                                //             <div className="d-xl-none tc d-md-none d-lg-none">
                                                //                 {t("Contract Number")}{" "}
                                                //             </div>
                                                //             <div>{rowData.parameter1 ? rowData.parameter1 : "None"}</div>
                                                //         </>
                                                //     ),
                                                //     headerStyle: {
                                                //         verticalAlign: "inherit",
                                                //         fontWeight: "bold",
                                                //         textAlign: "left",
                                                //     },
                                                //     cellStyle: {
                                                //         textAlign: "left",
                                                //         fontSize: 12,
                                                //     },
                                                // },
                                                // {
                                                //     title: `${t("Bill Through Date")}`,
                                                //     field: "parameter2",
                                                //     render: (rowData) => (
                                                //         <>
                                                //             <div className="d-xl-none tc d-md-none d-lg-none">
                                                //                 {t("Bill Through Date")}
                                                //             </div>
                                                //             <div>
                                                //                 {Helper.DateNormal(rowData.parameter2)}
                                                //             </div>
                                                //         </>
                                                //     ),
                                                //     // export: false,
                                                //     headerStyle: {
                                                //         verticalAlign: "inherit",
                                                //         fontWeight: "bold",
                                                //         textAlign: "left",
                                                //     },
                                                //     cellStyle: {
                                                //         textAlign: "left",
                                                //         fontSize: 12,
                                                //     },
                                                // }
                                                {
                                                    title: `${t("Request Date")}`,
                                                    field: "request_date",
                                                    render: (rowData) => (
                                                        <>
                                                            <div className="d-xl-none tc d-md-none d-lg-none">
                                                                {t("Request Date")}
                                                            </div>
                                                            <div>
                                                                {Helper.DateNormal(rowData.request_date)}
                                                            </div>
                                                        </>
                                                    ),
                                                    headerStyle: {
                                                        verticalAlign: "inherit",
                                                        fontWeight: "bold",
                                                        textAlign: "left",
                                                    },
                                                    cellStyle: {
                                                        textAlign: "left",
                                                        fontSize: 12,
                                                    },
                                                },

                                                {
                                                    title: `${t("Next Run")}`,
                                                    field: "next_run_date",
                                                    render: (rowData) => (
                                                        <>
                                                            <div className="d-xl-none tc d-md-none d-lg-none">
                                                                {t("Next Run")}
                                                            </div>
                                                            <div>
                                                                {rowData.next_run_date ? formatDate(rowData.next_run_date) : "—"}
                                                            </div>
                                                        </>
                                                    ),
                                                    headerStyle: {
                                                        verticalAlign: "inherit",
                                                        fontWeight: "bold",
                                                        textAlign: "left",
                                                    },
                                                    cellStyle: {
                                                        textAlign: "left",
                                                        fontSize: 12,
                                                    },
                                                },

                                                {
                                                    title: `${t("Status")}`,
                                                    field: "status",
                                                    render: (rowData) => (
                                                        <>
                                                            <div className="d-xl-none tc d-md-none d-lg-none">
                                                                {t("Status")}
                                                            </div>{" "}
                                                            <div
                                                                className={
                                                                    rowData.status === "success"
                                                                        ? "badge bg-gradient-success text-xxs"
                                                                        : rowData.status === "error" || rowData.status === "cancelled" ? "badge bg-gradient-danger text-xxs" : "badge badge-sm bg-gradient-secondary"
                                                                }
                                                            >
                                                                {rowData.status}
                                                            </div>
                                                        </>
                                                    ),
                                                    headerStyle: {
                                                        verticalAlign: "inherit",
                                                        fontWeight: "bold",
                                                        textAlign: "left",
                                                    },
                                                    cellStyle: {
                                                        textAlign: "left",
                                                        fontSize: 12,
                                                    },
                                                },
                                            ]}
                                            // data={items}
                                            data={(query) =>
                                                new Promise((resolve, reject) => {
                                                    const { orderBy, orderDirection } = query;

                                                    let url =
                                                        API + "processing/viewProcess/?";
                                                    url += "per_page=" + query.pageSize;
                                                    url += "&page=" + (query.page + 1);
                                                    url += "&search=" + query.search;
                                                    url += `&request_date=${selectedValue3
                                                        ? Helper.DatePicker(selectedValue3)
                                                        : ""
                                                        }`;
                                                    if (orderBy) {
                                                        url += `&orderBy=${orderBy.field}`;
                                                        url += `&orderDirection=${orderDirection}`;
                                                    }
                                                    fetch(url, { headers: authHeader() })
                                                        .then((response) => response.json())
                                                        .then((result) => {
                                                            resolve({
                                                                data:
                                                                    query.orderBy && query.orderDirection
                                                                        ? _.orderBy(
                                                                            result.data,
                                                                            [query.orderBy.field],
                                                                            [query.orderDirection]
                                                                        )
                                                                        : result.data,
                                                                page: result.page - 1,
                                                                totalCount: result.total,
                                                            });
                                                        });
                                                })
                                            }
                                            actions={[

                                                (rowData) => ({
                                                    icon: () => (
                                                        rowData.status === 'pending' ?
                                                            //   <img
                                                            //     src={
                                                            //       process.env.PUBLIC_URL +
                                                            //       "/static/images/ic-delete.svg"
                                                            //     }
                                                            //     alt="delete"
                                                            //   />
                                                            <i class="fa fa-solid fa-ban"></i>
                                                            : ''
                                                    ),
                                                    tooltip: "Cancel Process",

                                                    onClick: (event, rowData) => {
                                                        handelCancelSchedule(rowData.id, rowData.status);
                                                    },
                                                    hidden: rowData.status !== 'pending'
                                                }),
                                                (rowData) => ({
                                                    // icon: () => (
                                                    //     rowData.status === 'pending' && rowData.next_run_date ?
                                                    //         <i class="fa fa-solid fa-pen"></i>
                                                    //         : ''
                                                    // ),
                                                    icon: () => (
                                                        <img
                                                            src={process.env.PUBLIC_URL + "/static/images/ic-edit.svg"}
                                                            alt="edit"
                                                            style={{
                                                                visibility:
                                                                    rowData.status === "pending" && rowData.next_run_date
                                                                        ? "visible"
                                                                        : "hidden",
                                                            }}
                                                        />
                                                    ),
                                                    tooltip: "Edit Schedule",

                                                    onClick: (event, rowData) => {
                                                        openEditSchedule(rowData);
                                                    },
                                                    hidden: rowData.status !== 'pending' || !rowData.next_run_date
                                                }),
                                            ]}
                                            components={{
                                                Toolbar: props => (
                                                    <div className='MuiToolbar-root MTableToolbar-spacer-21  my-temp-class'>
                                                        <MTableToolbar {...props} />
                                                        <div
                                                            style={{
                                                                marginTop: "30px",
                                                                display: "flex",
                                                                justifyContent: "flex-end",
                                                                alignItems: "center",
                                                                gap: "10px",
                                                            }}
                                                        >
                                                            <button
                                                                type="button"
                                                                className="refreshRequest btn bg-gradient-secondary"
                                                                onClick={hadelRefresh}
                                                            >
                                                                {t("Refresh")}
                                                            </button>

                                                            {permissionss && permissionsArray.includes('add_processing') && (
                                                                <button
                                                                    type="button"
                                                                    disabled={disable}
                                                                    className="requestBilling btn btn-primary"
                                                                    onClick={() => setShowScheduler(true)}
                                                                >
                                                                    {t("Schedule")}
                                                                </button>
                                                            )}

                                                            <span
                                                                onClick={() => setState({ isPaneOpen: true })}
                                                                style={{
                                                                    color: "#b4b7c5",
                                                                    cursor: "pointer",
                                                                    display: "inline-flex", // Ensures the image aligns properly
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                <img
                                                                    src={process.env.PUBLIC_URL + '/static/images/ic-filter.svg'}
                                                                    alt=""
                                                                    style={{ height: "30px", marginLeft: "10px" }} // Adjust icon size if needed
                                                                />
                                                            </span>
                                                        </div>

                                                    </div>
                                                )
                                            }}
                                            options={{
                                                headerStyle: {
                                                    backgroundColor: "white",
                                                    color: "#245C7F",
                                                    fontSize: 12,
                                                },
                                                rowStyle: (rowData, index) => {
                                                    if (index % 2) {
                                                        return { backgroundColor: "#fff" };
                                                    }
                                                },
                                                sorting: true,
                                                search: false,
                                                toolbar: true,
                                                paging: true,
                                                pageSize: 10, // make initial page size
                                                emptyRowsWhenPaging: false, // To avoid of having empty rows
                                                pageSizeOptions: [10, 30, 35, 50],
                                                paginationType: "stepped",
                                                showFirstLastPageButtons: false,
                                                actionsColumnIndex: -1,
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <SlidingPane
                            className="some-custom-class sidepanebarprocess"
                            overlayClassName="custom-overlay"
                            isOpen={state2.isPaneOpen}
                            title="Porcess View"
                            subtitle=""
                            onRequestClose={() => {
                                setState2({ isPaneOpen: false });
                            }}
                        >
                            <div className="col-md-12">
                                <div className='row'>

                                    <div className="col-xl-6">
                                        <label className="col-lg-12 col-form-label">{t('Request ID')} <Tooltip content={t("requestid_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                    </div>
                                    <div className="col-xl-6">
                                        <span className="col-lg-8 view-label p">
                                            {request_id ? request_id : "None"}
                                        </span>
                                    </div>
                                    <div className="col-xl-6">
                                        <label className="col-lg-12 col-form-label">{t('Porcess Name')} <Tooltip content={t("processname_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                    </div>
                                    <div className="col-xl-6">
                                        <span className="col-lg-8 view-label p">
                                            {process_name === "Billing" ? "Generate Invoices" : process_name === "Notification" ? "Generate Notifications" : process_name === "Bucket" ? "Generate Aging Bucket" : process_name === "Contract Bulk Create" ? "Contract Bulk Create(QuickFi)" : process_name}
                                        </span>
                                    </div>
                                    <div className="col-xl-6">
                                        <label className="col-lg-12 col-form-label">{t('Parameter 1')} <Tooltip content={t("Parameter1_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                    </div>
                                    <div className="col-xl-6">
                                        <span className="col-lg-8 view-label p">
                                            {parameter1 ? parameter1 : "None"}
                                        </span>
                                    </div>
                                    <div className="col-xl-6">
                                        <label className="col-lg-12 col-form-label">{t('Parameter 2')} <Tooltip content={t("Parameter2_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                    </div>
                                    <div className="col-xl-6">
                                        <span className="col-lg-8 view-label p">
                                            {(parameter2) ? Helper.DateNormal(parameter2) : "None"}
                                        </span>
                                    </div>
                                    <div className="col-xl-6">
                                        <label className="col-lg-12 col-form-label">{t('Status')} <Tooltip content={t("status_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                    </div>
                                    <div className="col-xl-6">
                                        <span className="col-lg-8 view-label p">
                                            {status ? status : "None"}
                                        </span>
                                    </div>
                                    <div className="col-xl-6">
                                        <label className="col-lg-12 col-form-label">{t('Error Details')} <Tooltip content={t("errordetails_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                    </div>
                                    <div className="col-xl-6">
                                        <span className="col-lg-8 view-label p">
                                            {error_details ? error_details : "None"}
                                        </span>
                                    </div>
                                    <div className="col-xl-6">
                                        <label className="col-lg-12 col-form-label">{t('Next Run Date')} <Tooltip content={t("nextrundate_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                    </div>
                                    <div className="col-xl-6">
                                        <span className="col-lg-8 view-label p">
                                            {next_run_date ? formatDate(next_run_date) : "None"}
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </SlidingPane>
                        <SlidingPane
                            className="some-custom-class"
                            overlayClassName="some-custom-overlay-class"
                            isOpen={state3.isPaneOpen}
                            title="Edit Schedule"
                            subtitle=""
                            onRequestClose={() => {
                                setState3({ isPaneOpen: false });
                            }}
                        >
                            <div className="col-md-12">
                                <div className="col-lg-12 mb-3">
                                    <label className="col-lg-12 col-form-label">
                                        {t("New Date")}
                                    </label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={editDate}
                                        onChange={(e) => setEditDate(e.target.value)}
                                    />
                                </div>
                                <div className="col-lg-12 mb-3">
                                    <label className="col-lg-12 col-form-label">
                                        {t("New Time")}
                                    </label>
                                    <input
                                        type="time"
                                        className="form-control"
                                        value={editTime}
                                        onChange={(e) => setEditTime(e.target.value)}
                                    />
                                </div>
                                <div className="col-lg-12">
                                    <button
                                        type="button"
                                        className="btn bg-gradient-secondary ms-auto mb-0"
                                        onClick={() => setState3({ isPaneOpen: false })}
                                    >
                                        {t("Back")}
                                    </button>
                                    &nbsp;&nbsp;
                                    <button
                                        type="button"
                                        disabled={editSaving}
                                        onClick={handleSaveReschedule}
                                        className="btn btn-primary ms-auto mb-0"
                                    >
                                        {editSaving ? t("Saving...") : t("Save")}
                                    </button>
                                </div>
                            </div>
                        </SlidingPane>
                    </div>
                ) : (
                    <ContentLoader
                        viewBox="0 0 1000 550"
                        backgroundColor="rgba(0,0,0,0.06)"
                        foregroundColor="rgba(0,0,0,0.12)"
                    >
                        <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
                        <circle cx="879" cy="123" r="11" />
                        <circle cx="914" cy="123" r="11" />
                        <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
                        <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
                        <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
                        <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
                        <circle cx="880" cy="184" r="11" />
                        <circle cx="915" cy="184" r="11" />
                        <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
                        <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
                        <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
                        <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
                        <circle cx="881" cy="242" r="11" />
                        <circle cx="916" cy="242" r="11" />
                        <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
                        <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
                        <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
                        <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
                        <circle cx="882" cy="303" r="11" />
                        <circle cx="917" cy="303" r="11" />
                        <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
                        <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
                        <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
                        <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
                        <circle cx="881" cy="363" r="11" />
                        <circle cx="916" cy="363" r="11" />
                        <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
                        <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
                        <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
                        <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
                        <circle cx="882" cy="424" r="11" />
                        <circle cx="917" cy="424" r="11" />
                        <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
                        <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
                        <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
                        <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
                        <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
                        <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
                        <circle cx="882" cy="484" r="11" />
                        <circle cx="917" cy="484" r="11" />
                        <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
                        <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
                        <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
                        <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
                        <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
                        <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
                        <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
                        <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
                        <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
                        <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
                    </ContentLoader>
                )}
            </div>
        </div>
    )
}

export default ScheduleProcess